import { createStyles, makeStyles, Theme, ThemeColorsModel } from 'ui-components';

const FORM_COLUMN_WIDTH = 448;
const CONTENT_MAX_WIDTH = 1440;

export default makeStyles((theme: Theme & { color: ThemeColorsModel }) => createStyles({
  root: {
    display: 'block',
    minHeight: '100%',
    backgroundColor: theme.color.greys[15],
    padding: '64px 48px',

    [theme.breakpoints.down('sm')]: {
      padding: '40px 24px',
    },

    [theme.breakpoints.down('xs')]: {
      padding: '24px 16px',
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
    maxWidth: CONTENT_MAX_WIDTH,
    margin: '0 auto',

    [theme.breakpoints.down('md')]: {
      gap: 24,
    },
  },

  backLink: {
    alignSelf: 'flex-start',

    '&:focus-visible': {
      borderRadius: 4,
    },
  },

  layout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 40,
    '&:focus': {
      outline: 'none',
    },

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 24,
    },
  },

  formColumn: {
    backgroundColor: theme.color.greys[10],
    flex: `0 0 ${FORM_COLUMN_WIDTH}px`,
    maxWidth: FORM_COLUMN_WIDTH,

    [theme.breakpoints.down('md')]: {
      flex: '1 1 auto',
      maxWidth: '100%',
      width: '100%',
    },
  },

  previewColumn: {
    flex: '1 1 auto',
    alignSelf: 'stretch',
    minWidth: 0,
    width: '100%',
  },
}), { name: 'RetirementCalculatorLayout' });
